let product = JSON.parse(document.querySelector(".productContentProductsLabelInput:checked").value);
let activeVariant = product.variants[0];

/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    on: {
        slideChange: function () {
            // update the thumbnail active class
            document.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
            document.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
});

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        // remove play button
        this.querySelector(".productVisualSwiperSlidePlay").remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});


/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll(".productContentProductsLabelInput").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
})

let quantity = 1;

// update active variant
function updateProduct() {

    // parse product
    product = JSON.parse(document.querySelector(".productContentProductsLabelInput:checked").value);
    activeVariant = product.variants[0];

    // check if variant wasn't found
    if (activeVariant === null) {
        document.querySelector("#productContentATC").disabled = true;
        document.querySelector("#productContentATC").textContent = "Not Available";
        return;
    }

    // update text
    document.querySelector("#productContentATC").disabled = false;
    document.querySelector("#productContentATC").textContent = `BUY NOW - ${price(activeVariant.price, true)}`;

}

updateProduct()


/**************
 Product ATC
 ***************/

document.querySelector("#productContentATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: 1,
            id: activeVariant.id,
        }]
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});